import React from 'react'
import ProfileMenu from './profile'

export default class NavigationMenu extends React.Component {
  render() {
    return (
      <ProfileMenu/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js